<template>
  <div>
    <md-dialog :md-active.sync="openDialog" @md-closed="() => $emit('close')">
      <md-dialog-title>Importar Comando</md-dialog-title>

      <div class="pl-4 pr-4" style="width: 50vw">
        <md-field>
          <label :for="`importar${_uid}`">Comando</label>

          <md-textarea v-model="comando" />
        </md-field>
      </div>

      <md-dialog-actions>
        <md-button class="md-primary" @click="() => $emit('close')">
          Fechar
        </md-button>
        <md-button class="md-raised md-primary" @click="handleImportarComando">
          Importar
        </md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>
<script>
import http from '@/utils/http'

export default {
  name: 'MotoBombaImportarComando',
  props: {
    openDialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      openFormImportarComando: false,
      comando: '',
    }
  },
  methods: {
    handleImportarComando() {
      http
        .post(
          'equipamento/calibracao/configuracao/importar-comando/moto-bomba',
          {
            comando: this.comando,
          }
        )
        .then((value) =>
          value.comandos.map((e) => ({
            ...e,
            horario: e.horario ?? {
              inicio: '',
              fim: '',
            },
          }))
        )
        .then((data) => {
          this.$emit('comando', data)
        })
    },
  },
}
</script>
